import gql from "graphql-tag";
export const getRecordsQuery = gql`
  query GetRecords($authToken: String, $appId: String!) {
    livingapi(authToken: $authToken) {
      viewtemplateData(id: $appId) {
        app {
          wer2: control(identifier: "wer2") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          was2: control(identifier: "was2") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          notiz: control(identifier: "notiz") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          bild: control(identifier: "bild") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          standort: control(identifier: "standort") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          bewertung: control(identifier: "bewertung") {
            ... on LookupControlType {
              control {
                id
                type
                subtype
                lookupdata {
                  key
                  label
                }
              }
            }
          }
          status: control(identifier: "status") {
            ... on LookupControlType {
              control {
                id
                type
                subtype
                lookupdata {
                  key
                  label
                }
              }
            }
          }
          aktion: control(identifier: "aktion") {
            ... on StandardControlType {
              control {
                id
                type
                subtype
              }
            }
          }
          durch_wen2: control(identifier: "durch_wen2") {
            ... on LookupControlType {
              control {
                id
                type
                subtype
                lookupdata {
                  key
                  label
                }
              }
            }
          }
          records {
            id
            wer2: value(identifier: "wer2") {
              ... on ValueTypeString {
                value
              }
            }
            was2: value(identifier: "was2") {
              ... on ValueTypeString {
                value
              }
            }
            notiz: value(identifier: "notiz") {
              ... on ValueTypeString {
                value
              }
            }
            bild: value(identifier: "bild") {
              ... on ValueTypeFile {
                value {
                  id
                  url
                  filename
                  mimetype
                  width
                  height
                  createdat
                }
              }
            }
            standort: value(identifier: "standort") {
              ... on ValueTypeGeo {
                value {
                  lat
                  lng
                  info
                }
              }
            }
            bewertung: value(identifier: "bewertung") {
              ... on ValueTypeLookUpItem {
                value {
                  key
                  label
                }
              }
            }
            status: value(identifier: "status") {
              ... on ValueTypeLookUpItem {
                value {
                  key
                  label
                }
              }
            }
            aktion: value(identifier: "aktion") {
              ... on ValueTypeString {
                value
              }
            }
            durch_wen2: value(identifier: "durch_wen2") {
              ... on ValueTypeLookUpItem {
                value {
                  key
                  label
                }
              }
            }
          }
        }
      }
    }
  }
`;
